// extracted by mini-css-extract-plugin
export default {"wrapper":"xSbsn","content":"Sse8W","textContent":"jd20g","title":"_RLJr","text":"vgj4d","button":"PcU5a","imgWrapper":"kgZGh","img":"yUxgG"};